export enum PhoneWidgetBusinessEvent {
  PhoneWidgetCallFromKeyboard = 'Phone Widget - Call from keyboard',
  PhoneWidgetCallFromSearch = 'Phone Widget - Call from search',
  PhoneWidgetOpenKeyboard = 'Phone Widget - Open keyboard',
  PhoneWidgetOpenInternalTransferPanel = 'Phone Widget - Open Internal Transfer',
  PhoneWidgetInitializeInternalTransfer = 'Phone Widget - Initialize Internal Transfer',
  PhoneWidgetDisconnected = 'Phone Widget - Disconnected',
  PhoneWidgetLoginWorkstation = 'Login - Workstation',
}
